if (!window.kodaCardSwatchInitialized) {
  window.kodaCardSwatchInitialized = true;

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-koda-card-swatch]');
    if (!swatch) return;

    var imageUrl = swatch.dataset.imageUrl;
    if (!imageUrl) return;

    var card = swatch.closest('.koda-card');
    var image = card && card.querySelector('.koda-card__image');
    if (image) {
      image.removeAttribute('srcset');
      image.src = imageUrl;
    }

    var siblings = swatch.parentElement.querySelectorAll('[data-koda-card-swatch]');
    siblings.forEach(function (sibling) {
      sibling.classList.remove('is-active');
    });
    swatch.classList.add('is-active');

    var variantId = swatch.dataset.variantId;
    if (!variantId || !card) return;

    var addToCartButton = card.querySelector('[data-koda-add-to-cart]');
    if (addToCartButton) {
      addToCartButton.dataset.variantId = variantId;

      if (swatch.dataset.variantAvailable === 'false') {
        addToCartButton.setAttribute('disabled', 'disabled');
        addToCartButton.classList.add('is-unavailable');
      } else {
        addToCartButton.removeAttribute('disabled');
        addToCartButton.classList.remove('is-unavailable');
      }
    }

    if (swatch.dataset.variantPrice) {
      var priceEl = card.querySelector('[data-koda-card-price]');
      if (priceEl) priceEl.textContent = swatch.dataset.variantPrice;

      var installmentValueEl = card.querySelector('[data-koda-card-installment-value]');
      if (installmentValueEl) installmentValueEl.textContent = swatch.dataset.variantInstallmentValue;

      var normalPriceEl = card.querySelector('[data-koda-card-normal-price]');
      if (normalPriceEl) normalPriceEl.textContent = swatch.dataset.variantPrice;

      var compareRowEl = card.querySelector('[data-koda-card-compare-row]');
      var compareEl = card.querySelector('[data-koda-card-compare]');
      if (compareRowEl && compareEl) {
        if (swatch.dataset.variantHasCompare === 'true') {
          compareEl.textContent = swatch.dataset.variantComparePrice;
          compareRowEl.style.display = '';
        } else {
          compareRowEl.style.display = 'none';
        }
      }
    }
  });
}

if (!window.kodaCardAddToCartInitialized) {
  window.kodaCardAddToCartInitialized = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-koda-add-to-cart]');
    if (!button || button.hasAttribute('disabled')) return;

    event.preventDefault();
    event.stopPropagation();

    var variantId = button.dataset.variantId;
    if (!variantId) return;

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    button.setAttribute('disabled', 'disabled');
    button.classList.add('is-loading');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    if (cart) {
      cart.getSectionsToRender().forEach(function (section) {
        formData.append('sections', section.id);
      });
      formData.append('sections_url', window.location.pathname);
    }

    var config = fetchConfig('javascript');
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          button.classList.add('is-error');
          window.setTimeout(function () {
            button.classList.remove('is-error');
          }, 1500);
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'card-product',
            productVariantId: variantId,
            cartData: response,
          });
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        }

        button.classList.add('is-added');
        window.setTimeout(function () {
          button.classList.remove('is-added');
        }, 1500);
      })
      .catch(function (error) {
        console.error(error);
        button.classList.add('is-error');
        window.setTimeout(function () {
          button.classList.remove('is-error');
        }, 1500);
      })
      .finally(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('disabled');
      });
  });
}
